import { render, staticRenderFns } from "./FormCreateProduct.vue?vue&type=template&id=12db1588&scoped=true&"
import script from "./FormCreateProduct.vue?vue&type=script&lang=js&"
export * from "./FormCreateProduct.vue?vue&type=script&lang=js&"
import style0 from "./FormCreateProduct.vue?vue&type=style&index=0&id=12db1588&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db1588",
  null
  
)

export default component.exports